export const kennitalaFormat = /^[0-9]{6}[- ]?[0-9]{4}[- ]*$/;

export const posturinnShipmentTrackingNumberRegex = /^[a-zA-Z]{2}[0-9]{8}[0-9X]([a-zA-Z]{2}|[0-9]{2})$/;

export const posturinnReturnedShipmentTrackingNumberRegex = /^[a-zA-Z]{2}[0-9]{8}[eE](is|IS|iS|Is|[0-9]{2})$/;

export const dhlShipmentTrackingNumberRegex = /^[0-9]{10}$/;

export const trackingNumberRegex = /^[a-zA-Z0-9/-]{8,35}$/;

export const noIcelandicLettersInEmailRegex = /^((?!ö|þ|ð|é|æ|á|í|ý|ú|ó).)*$/;

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const posturinnAndExternalShipmentsId = /^[a-zA-Z0-9/-]{8,30}$/;

export const domesticShipmentPhoneRegex = /^[6-8]\d{6}$/;

export const icelandicShipmentPhoneRegex = /^(?:\+354|00354)?[0-9]{7}$/;

export const icelandicShipmentPhoneWithCountryCodeRegex = /^(?:\+354|00354)[0-9]*$/;

export const icelandicMobileShipmentPhoneRegex = /^(?:\+354|00354)?[6-8]\d{6}$/;

export const internationalShipmentPhoneWithPlusRegex = /^\+[1-9]\d{7,13}$/;

export const internationalShipmentPhoneWithDoubleZeroRegex = /^00[1-9]\d{7,13}$/;
